import React, {Fragment} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import user_routes from './navs/UserNav'
import admin_routes from './navs/AdminNav'
import admin_routes_ppr from './navs/AdminNavPPR'
import user_routes_ppr from './navs/UserNavPPR'
import report_routes from "./navs/ReportNav";
import report_routes_ppr from "./navs/ReportNavPPR";
import {Button, Menu, Space, Tooltip} from 'antd';
import {
    AppstoreFilled,
    AndroidOutlined,
    AppleOutlined,
    CalendarOutlined
} from '@ant-design/icons';
import './index.css';
import { useI18n } from '../../i18n';

function Aside(props) {
    const { t } = useI18n();
    const pathname = props?.location?.pathname;
    const collapsed = props?.collapsed;

    let routes
    const role = parseInt(localStorage.getItem('userRole'))
    const userId = parseInt(localStorage.getItem('userId'))
const ppr_lists=[2031, 632, 1727, 887, 889, 174, 896, 894, 892, 893, 895, 1593, 1726, 1725, 959, 1724, 2168, 2315,1,753,2243]
    if (role === 1 || role === 2) {
        if (ppr_lists.includes(userId)){

            routes = admin_routes_ppr
        }
        else{
            routes=admin_routes
        }
        
    } else if (role === 3) {

        
        if (ppr_lists.includes(userId)){
            routes = report_routes_ppr
        }
        else{

            routes = report_routes
        }
       
    } else {

        if (ppr_lists.includes(userId)){
            routes = user_routes_ppr
        }
        else{

            routes = user_routes
        }
       
    }
    routes = routes || [];

    // Find active route key with support for sub-routes
    const findActiveKey = () => {
        if (!pathname) return [];

        // Exact match
        const exact = routes.find((e) => e?.path && pathname === e.path);
        if (exact) return [`${exact.key}`];

        // Process Journal and its nested sub-journals (/TechnologyJournal, /ZonesJournal, /ConditionJournal, etc.)
        if (
            pathname.startsWith('/ProcessJournal') ||
            pathname.startsWith('/TechnologyJournal') ||
            pathname.startsWith('/ZonesJournal') ||
            pathname.startsWith('/ConditionJournal') ||
            pathname.startsWith('/OperationsJournal') ||
            pathname.startsWith('/NewTaskTypeJournal')
        ) {
            const processRoute = routes.find((e) => e?.path === '/ProcessJournal');
            if (processRoute) return [`${processRoute.key}`];
        }

        // Work type references sub-journals
        if (pathname.startsWith('/work-type-journal') || pathname.startsWith('/edit-work-type-journal')) {
            const wtRoute = routes.find((e) => e?.path === '/work-type-journal');
            if (wtRoute) return [`${wtRoute.key}`];
        }

        // PPR Calendar sub-routes
        if (pathname.startsWith('/calendar') || pathname.startsWith('/ppr_table')) {
            const pprRoute = routes.find((e) => e?.path === '/ppr_table' || (e?.path && e.path.startsWith('/calendar')));
            if (pprRoute) return [`${pprRoute.key}`];
        }

        // Generic prefix match (excluding '/' or '/main')
        const prefixMatch = routes.find((e) => e?.path && e.path !== '/' && e.path !== '/main' && pathname.startsWith(e.path));
        if (prefixMatch) return [`${prefixMatch.key}`];

        // Main match only if strictly on '/' or '/main'
        if (pathname === '/' || pathname === '/main') {
            const mainRoute = routes.find((e) => e?.path === '/main');
            if (mainRoute) return [`${mainRoute.key}`];
        }

        return [];
    };

    const selectedKeys = findActiveKey();

    const getRouteName = (item) => {
        const pathMap = {
            '/main': t('nav.main', 'Главная'),
            '/create-task-new': t('nav.create_task', 'Создать Наряд-задание'),
            '/create-task': t('nav.create_task_old', 'Создать наряд (старый)'),
            '/electro-journal': t('nav.electro_journal', 'Наряд-допуск (электро)'),
            '/non-electro-journal': t('nav.non_electro_journal', 'Наряд-допуск (не электро)'),
            '/operation': t('nav.operation', 'Распоряжение'),
            '/current-operation': t('nav.current_operation', 'Работа в порядке текущей эксплуатации'),
            '/weather-journal': t('nav.weather_journal', 'Журнал погоды'),
            '/user-journal': t('nav.users', 'Пользователи'),
            '/ProcessJournal': t('nav.processes', 'Виды процессов'),
            '/work-type-journal': t('nav.references', 'Справочник'),
            '/instructions': t('nav.instructions', 'Инструкции'),
            '/report': t('nav.reports', 'Отчеты'),
            '/smax': 'Smax',
            '/smax_journal': t('nav.smax_journal', 'Журнал СМАКС'),
            '/ppr_table': t('nav.ppr', 'График ППР'),
        };
        if (item?.path) {
            if (pathMap[item.path]) return pathMap[item.path];
            if (item.path.startsWith('/calendar')) return t('nav.ppr', 'График ППР');
        }

        const nameMap = {
            'Главная': t('nav.main', 'Главная'),
            'Создать Наряд-задание': t('nav.create_task', 'Создать Наряд-задание'),
            'Создать наряд (старый)': t('nav.create_task_old', 'Создать наряд (старый)'),
            'Наряд-допуск (электро)': t('nav.electro_journal', 'Наряд-допуск (электро)'),
            'Наряд-допуск (не электро)': t('nav.non_electro_journal', 'Наряд-допуск (не электро)'),
            'Распоряжение': t('nav.operation', 'Распоряжение'),
            'Работа в порядке текущей эксплуатации': t('nav.current_operation', 'Работа в порядке текущей эксплуатации'),
            'График ППР': t('nav.ppr', 'График ППР'),
            'Журнал погоды': t('nav.weather_journal', 'Журнал погоды'),
            'Журнал СМАКС': t('nav.smax_journal', 'Журнал СМАКС'),
            'Пользователи': t('nav.users', 'Пользователи'),
            'Инструкции': t('nav.instructions', 'Инструкции'),
            'Справочник': t('nav.references', 'Справочник'),
            'Виды процессов': t('nav.processes', 'Виды процессов'),
            'Отчеты': t('nav.reports', 'Отчеты'),
        };
        return nameMap[item?.name] || t(item?.name, item?.name) || '';
    };

    return (
        <div className='aside-container'>
            <Menu 
                theme='dark' 
                mode='inline' 
                selectedKeys={selectedKeys} 
                onClick={() => {
                    if (typeof props.onItemClick === 'function') {
                        props.onItemClick();
                    }
                }}
                style={{ borderRight: 0, flex: 1, overflowY: 'auto' }}
            >
                {routes.map((item) => {
                    return (
                        <Menu.Item key={item.key} icon={item.icon}>
                            <NavLink to={item.path}>{getRouteName(item)}</NavLink>
                        </Menu.Item>
                    );
                })}
            </Menu>

            <div className='aside-download-section'>
                <Tooltip title={collapsed ? t('nav.download_playmarket', 'Скачать с PlayMarket') : ''} placement='right'>
                    <a
                        href='https://play.google.com/store/apps/details?id=kz.ttc.app'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='aside-download-btn'
                    >
                        <AndroidOutlined className='aside-download-icon' style={{ color: '#ffffff' }} />
                        <span className='aside-download-text'>{t('nav.download_playmarket', 'Скачать с PlayMarket')}</span>
                    </a>
                </Tooltip>
                <Tooltip title={collapsed ? t('nav.download_appstore', 'Скачать с AppStore') : ''} placement='right'>
                    <a
                        href='https://apps.apple.com/kz/app/%D1%8D%D0%BD%D0%B7%D0%BF/id1593204512'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='aside-download-btn'
                    >
                        <AppleOutlined className='aside-download-icon' style={{ color: '#ffffff' }} />
                        <span className='aside-download-text'>{t('nav.download_appstore', 'Скачать с AppStore')}</span>
                    </a>
                </Tooltip>
            </div>
        </div>
    );
}

export default withRouter(Aside);

